import { fetchAPI } from ".";

export const getAllServiceAndApplications = async (
  searchKeyword = null,
  filterCategoryId = null,
  page,
  pageSize
) => {
  console.log(
    "searchKeyword : ",
    searchKeyword,
    " filterCategoryId : ",
    filterCategoryId,
    " page : ",
    page,
    " pageSize : ",
    pageSize
  );
  try {
    const baseUrl = `/o/c/applicationandservices/scopes/${themeDisplay.getSiteGroupId()}`;
    const params = new URLSearchParams();
    params.append(
      "fields",
      "id,title,description,serviceType,accessApplicationURL,dateCreated,taxonomyCategoryBriefs,openInANewWindow"
    );

    if (searchKeyword) {
      params.append("search", searchKeyword);
    }

    if (filterCategoryId || filterCategoryId != "") {
      const filter = `(taxonomyCategoryIds/any(t:t eq ${filterCategoryId}))`;
      params.append("filter", filter);
    }

    if (page) params.append("page", page);
    if (pageSize) params.append("pageSize", pageSize);

    params.append("sort", "dateModified:desc");

    const url = `${baseUrl}?${params.toString()}`;
    console.log("Generated URL: ", url);

    const response = await fetchAPI(url, "GET", null);
    return response;
  } catch (error) {
    console.error("Error getting applications :", error);
  }
};

export const getAllCategories = async (vocabId) => {
  try {
    const baseUrl = `/o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${vocabId}/taxonomy-categories`;
    const params = new URLSearchParams();
    params.append("fields", "id,name");
    params.append("pageSize", -1);
    params.append("restrictField", "actions,creator");

    const url = `${baseUrl}?${params.toString()}`;
    console.log("Generated URL: ", url);

    const response = await fetchAPI(url, "GET", null);
    console.log("response : ", response?.items);
    return response?.items;
  } catch (error) {
    console.error("Error getting applications :", error);
  }
};
